<!-- <block-ui> -->
    <ngx-spinner 
        size = "default" 
        type="ball-clip-rotate"
    >
        <p style="color: rgb(196, 196, 196);">Loading... </p>
    </ngx-spinner>
    <router-outlet></router-outlet>
<!-- </block-ui> -->